import { useCampaignContext } from 'modules/campaigns/editor/context';
import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { EmbeddedMessage } from 'constants/messageMediums';

import { CampaignFormField, ReadOnlyField } from '../../FormFields';
import { SectionWrapper } from '../Sections.styled';
import { SampleApiRequestCodeBox } from './SampleApiRequestCodeBox';

import { JourneyLink } from '../JourneyLink';
import { JourneyNodeId } from '../JourneyNodeId';

export const AUDIENCE_TRIGGERED_SECTION_TEST_ID = 'audience-triggered-section';
export const SAMPLE_API_REQUEST_LABEL = 'Sample API request';
const TRIGGER_LABEL = 'Trigger';
export const API_LABEL = 'API';
export const WORKFLOW_LABEL = 'Journey triggered';

const StyledCampaignFormField = styled(CampaignFormField)`
  margin-top: ${spacing.plusHalf};
  margin-bottom: 0;
`;

export const AudienceTriggeredSection = () => {
  const { campaign } = useCampaignContext();
  const journey = campaign?.journey;
  const isJourneyAssociated = campaign?.isJourneyAssociated;
  const isEmbeddedJourneyCampaign = campaign?.messageMedium === EmbeddedMessage;

  const getTriggerLabel = () => {
    if (journey) return <JourneyLink journey={journey} />;
    else if (isJourneyAssociated && isEmbeddedJourneyCampaign) return WORKFLOW_LABEL;
    else return API_LABEL;
  };

  return (
    <SectionWrapper data-test={AUDIENCE_TRIGGERED_SECTION_TEST_ID}>
      <StyledCampaignFormField labelText={TRIGGER_LABEL}>
        <ReadOnlyField name="trigger">{getTriggerLabel()}</ReadOnlyField>
        {journey && <JourneyNodeId journey={journey} campaignId={campaign.id} />}
      </StyledCampaignFormField>
      {!isEmbeddedJourneyCampaign && (
        <StyledCampaignFormField labelText={SAMPLE_API_REQUEST_LABEL}>
          <SampleApiRequestCodeBox />
        </StyledCampaignFormField>
      )}
    </SectionWrapper>
  );
};
